import React, { useCallback } from "react";
import copyIcon from "/app/src/components/generic/title/copyIcon.svg";
import { reportService } from "/app/src/services";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { buildParams } from "/app/src/helpers/params";
import { useQueryClient } from "@tanstack/react-query";
import HeroButton from "/app/src/components/HeroUi/Button";
import HeroModal from "/app/src/components/HeroUi/Modal";
import ModalBuilder from "/app/src/components/HeroUi/helpers/ModalBuilder";
import { useDisclosure } from "@heroui/react";

/**
 * Returns a button that duplicates a report
 * @param param0 Id of report to duplicate
 */
export default function DuplicateReport({ reportId }: { reportId: number }) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const { isOpen, onOpen, onOpenChange } = useDisclosure();

  /**
   * Duplicate a report, invalidate the cache and navigate to the new report
   */
  const duplicateReport = useCallback(() => {
    reportService
      .duplicateReport({ reportId }, buildParams({ copy: "True" }))
      .then((response) => {
        queryClient.invalidateQueries({ queryKey: ["reports"] });
        queryClient.invalidateQueries({ queryKey: ["reportsCount"] });
        navigate(`/reports/${response.report.id}`);
      });
  }, [reportId, queryClient, navigate]);
  return (
    <>
      <button className="buttonless" onClick={onOpen} onKeyDown={onOpen}>
        <img style={{ marginRight: "10px" }} src={copyIcon} alt="Copy" />
      </button>
      <HeroModal
        disableAnimation={false}
        isOpen={isOpen}
        onOpenChange={onOpenChange}
        placement="top"
      >
        {ModalBuilder({
          warning: true,
          modalHeader: t("translation:confirm_copy_report"),
          modalFooter: (
            <>
              <HeroButton
                size="sm"
                color="default"
                variant="bordered"
                onClick={onOpenChange}
              >
                {t("translation:do_not_copy")}
              </HeroButton>
              <HeroButton size="sm" color="primary" onClick={duplicateReport}>
                {t("translation:copy")}
              </HeroButton>
            </>
          ),
        })}
      </HeroModal>
    </>
  );
}
